import React from 'react';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes, observer, inject } from 'mobx-react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';

import { modelOf } from '../../../prop-types';
import Category from '../../../models/Category';
import CategorySliderControls from '../../category/CategorySliderControls';
import NavigationCategoryButton from '../NavigationCategoryButton';
import ConfigStore from '../../../store/ConfigStore';
import NavigationCategoryImage from '../NavigationCategoryImage';
import useHorizontalScrollState from '../../../hooks/common/useHorizontalScrollState';

const messages = defineMessages({
  productCategoriesTitle: {
    id: 'navigation.productCategoriesTitle',
    defaultMessage: 'Product categories',
  },
  productCategoriesAriaLabel: {
    id: 'navigation.productCategoriesAriaLabel',
    defaultMessage: 'Select product category',
  },
});

const NavigationCategorySlider = ({ configStore, categories, intl }) => {
  const { scrollRef, scrollState, scrollBy } = useHorizontalScrollState({
    deps: [categories],
  });

  const getCategoryItems = () => {
    return categories.map((category) => (
      <li key={category.id}>
        {configStore.navigation.common.useCategorySliderImages ? (
          <NavigationCategoryImage category={category} />
        ) : (
          <NavigationCategoryButton category={category} />
        )}
      </li>
    ));
  };

  return (
    <nav
      className="NavigationCategorySlider"
      aria-label={intl.formatMessage(messages.productCategoriesAriaLabel)}
    >
      <div className="NavigationCategorySlider__header">
        <h2>{intl.formatMessage(messages.productCategoriesTitle)}</h2>
        {scrollState.hasOverflow && (
          <CategorySliderControls
            canScrollLeft={scrollState.canScrollLeft}
            canScrollRight={scrollState.canScrollRight}
            onScrollLeft={() => scrollBy(-1)}
            onScrollRight={() => scrollBy(1)}
          />
        )}
      </div>
      <ul ref={scrollRef} className="NavigationCategorySlider__items">
        {getCategoryItems()}
      </ul>
    </nav>
  );
};

NavigationCategorySlider.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  categories: PropTypes.oneOfType([
    MobxPropTypes.observableArrayOf(modelOf(Category)).isRequired,
    PropTypes.arrayOf(modelOf(Category)).isRequired,
  ]),
  intl: intlShape.isRequired,
};

export default inject('configStore')(
  injectIntl(observer(NavigationCategorySlider))
);
